<template>
    <div>
      <!-- NAVBAR -->
      <my-navbar :controller="controller" />

      <!-- HEADER -->
      <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8 hide">
        <div class="container-fluid">
          <div class="header-body">
            <div class="row">
              <!-- CONTENIDO HEADER -->
            </div>
          </div>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="container-fluid mt--7">
        <div class="row">
          <div class="col">
            <!-- COMPONENTE PRINCIPAL -->
            <div class="row">
              <div class="col-lg-12">
                <div class="wrapper">
                  <div class="card">
                      <div class="card-body">
                        <latam-plugin-cs component="certified-vehicles" certifiedvehiclestenant="chileautos"></latam-plugin-cs>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

</template>
<script>
export default {
  name: "CertifiedVehicles",
  data() {
    return {
      loading: false,
      controller: {
        title: "Vehículos Certificados",
        mainRouter: "/"
      }
    };
  },
  mounted() {
    this.loadPlugins();
  },
  methods: {
    loadPlugins() {
      const urlBase = process.env.VUE_APP_GLOBAL_PLUGINS;
      const v = new Date().getDate();

      let pluginScript = document.createElement("script");
      pluginScript.setAttribute(
        "src",
        `${urlBase}/script-es2015.js?v=${v}`
      );
      document.head.appendChild(pluginScript);

      let pluginStyle = document.createElement("link");
      pluginStyle.setAttribute("rel", "stylesheet");
      pluginStyle.setAttribute(
        "href",
        `${urlBase}/style.min.css?v=${v}`
      );
      document.head.appendChild(pluginStyle);
    }
  }
};
</script>
<style lang="scss" scoped></style>